import { Lock, Shield, Database, Check } from "lucide-react";

const dataPoints = [
  "Photo",
  "Âge",
  "Taille",
  "Poids",
  "Objectifs",
];

const guarantees = [
  {
    icon: Lock,
    title: "Jamais vendues, jamais partagées",
    text: "Tes données t'appartiennent. Aucune revente, aucun partage avec des tiers.",
  },
  {
    icon: Database,
    title: "Stockage local ou Supabase sécurisé",
    text: "Choisis où tes données vivent : sur ton appareil ou sur des serveurs chiffrés.",
  },
  {
    icon: Shield,
    title: "Chiffrement de bout en bout",
    text: "Tes photos et informations sont protégées à chaque étape de leur traitement.",
  },
];

export default function Privacy() {
  return (
    <section
      id="confidentialite"
      data-testid="privacy-section"
      className="py-24 lg:py-32 px-6 lg:px-10 bg-neutral-50 border-y border-neutral-200"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-start">
          {/* Left */}
          <div>
            <p className="text-sm font-medium text-violet-600 mb-4 uppercase tracking-wider">
              Confidentialité
            </p>
            <h2
              data-testid="privacy-title"
              className="text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.1] text-neutral-950 mb-8"
            >
              Tes données restent à toi. Toujours.
            </h2>
            <p className="text-lg text-neutral-600 leading-relaxed mb-8">
              Pour personnaliser ton expérience, Lift AI collecte uniquement les
              informations nécessaires à l'analyse de ton physique et à la
              création de ton programme.
            </p>

            <div
              data-testid="data-collected"
              className="flex flex-wrap gap-2"
            >
              {dataPoints.map((d) => (
                <span
                  key={d}
                  className="inline-flex items-center gap-2 text-sm bg-white border border-neutral-200 text-neutral-800 px-4 py-2 rounded-full"
                >
                  <Check size={14} className="text-violet-600" />
                  {d}
                </span>
              ))}
            </div>
          </div>

          {/* Right */}
          <div className="flex flex-col gap-4">
            {guarantees.map((g, i) => (
              <div
                key={g.title}
                data-testid={`privacy-guarantee-${i}`}
                className="group flex gap-5 bg-white border border-neutral-200 rounded-2xl p-6 transition-all duration-300 hover:border-violet-500/50"
              >
                <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-violet-50 border border-violet-200 flex items-center justify-center">
                  <g.icon size={20} className="text-violet-600" />
                </div>
                <div>
                  <h3 className="text-base font-semibold tracking-tight text-neutral-950 mb-1">
                    {g.title}
                  </h3>
                  <p className="text-sm text-neutral-600 leading-relaxed">
                    {g.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
